import { Component, type ErrorInfo, type ReactNode } from "react";

type AppErrorBoundaryProps = {
  children: ReactNode;
  scope?: "root" | "admin" | "chat" | "wizard";
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  public state: AppErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("AppErrorBoundary", {
      scope: this.props.scope ?? "root",
      error,
      errorInfo,
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className='mx-auto my-10 max-w-xl rounded-2xl border border-rose-200 bg-rose-50 p-6 text-center'>
          <h2 className='text-lg font-semibold text-rose-700'>
            Ocurrio un error en esta seccion
          </h2>
          <p className='mt-2 text-sm text-rose-600'>
            Puedes recargar la pagina para intentar nuevamente.
          </p>
          <button
            type='button'
            onClick={this.handleReload}
            className='mt-4 rounded-full bg-rose-600 px-5 py-2 text-sm font-semibold text-white hover:bg-rose-700'
          >
            Recargar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
